import { PERFORMANCE_OEM_LABS_CONSTANTS } from "./constants";
import CardsList from "@/components/cardsList";

const ImportanceComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 4 }}
      title={PERFORMANCE_OEM_LABS_CONSTANTS.title}
      desc={PERFORMANCE_OEM_LABS_CONSTANTS.desc}
      list={PERFORMANCE_OEM_LABS_CONSTANTS.list}
      spacing={{ base: 8, md: 16 }}
      hoverEffect
    />
  );
};

export default ImportanceComponent;
